/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Offerhover_Agerating2Inputs */

const id_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat Usia:`)
};

const ms_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penarafan Umur:`)
};

const da_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aldersvurdering:`)
};

const de_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altersfreigabe:`)
};

const en_us2_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age Rating:`)
};

const es_es2_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación por edad:`)
};

const es_mx2_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación por edad:`)
};

const fil_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating ng Edad:`)
};

const fr_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classification :`)
};

const it_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificazione età:`)
};

const hu_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korhatár besorolás:`)
};

const nl_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeftijdsclassificatie:`)
};

const no_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aldersvurdering:`)
};

const pl_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasyfikacja wiekowa:`)
};

const pt_br2_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação etária:`)
};

const pt_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação etária:`)
};

const ro_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificare de vârstă:`)
};

const fi_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikäraja:`)
};

const sv_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åldersklassificering:`)
};

const vi_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng độ tuổi:`)
};

const tr_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaş Sınırı:`)
};

const cs_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Věkové hodnocení:`)
};

const bg_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Възрастово ограничение:`)
};

const ru_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возрастной рейтинг:`)
};

const uk_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Віковий рейтинг:`)
};

const ar_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التصنيف العمري:`)
};

const hi_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयु रेटिंग:`)
};

const th_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรตอายุ:`)
};

const ja_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齢レーティング：`)
};

const zh_cn2_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年龄分级:`)
};

const zh_hant1_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年齡分級：`)
};

const ko_home_offerhover_agerating2 = /** @type {(inputs: Home_Offerhover_Agerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연령 등급:`)
};

/**
* | output |
* | --- |
* | "Age Rating:" |
*
* @param {Home_Offerhover_Agerating2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_offerhover_agerating2 = /** @type {((inputs?: Home_Offerhover_Agerating2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Offerhover_Agerating2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_offerhover_agerating2(inputs)
	if (locale === "ms") return ms_home_offerhover_agerating2(inputs)
	if (locale === "da") return da_home_offerhover_agerating2(inputs)
	if (locale === "de") return de_home_offerhover_agerating2(inputs)
	if (locale === "en-US") return en_us2_home_offerhover_agerating2(inputs)
	if (locale === "es-ES") return es_es2_home_offerhover_agerating2(inputs)
	if (locale === "es-MX") return es_mx2_home_offerhover_agerating2(inputs)
	if (locale === "fil") return fil_home_offerhover_agerating2(inputs)
	if (locale === "fr") return fr_home_offerhover_agerating2(inputs)
	if (locale === "it") return it_home_offerhover_agerating2(inputs)
	if (locale === "hu") return hu_home_offerhover_agerating2(inputs)
	if (locale === "nl") return nl_home_offerhover_agerating2(inputs)
	if (locale === "no") return no_home_offerhover_agerating2(inputs)
	if (locale === "pl") return pl_home_offerhover_agerating2(inputs)
	if (locale === "pt-BR") return pt_br2_home_offerhover_agerating2(inputs)
	if (locale === "pt") return pt_home_offerhover_agerating2(inputs)
	if (locale === "ro") return ro_home_offerhover_agerating2(inputs)
	if (locale === "fi") return fi_home_offerhover_agerating2(inputs)
	if (locale === "sv") return sv_home_offerhover_agerating2(inputs)
	if (locale === "vi") return vi_home_offerhover_agerating2(inputs)
	if (locale === "tr") return tr_home_offerhover_agerating2(inputs)
	if (locale === "cs") return cs_home_offerhover_agerating2(inputs)
	if (locale === "bg") return bg_home_offerhover_agerating2(inputs)
	if (locale === "ru") return ru_home_offerhover_agerating2(inputs)
	if (locale === "uk") return uk_home_offerhover_agerating2(inputs)
	if (locale === "ar") return ar_home_offerhover_agerating2(inputs)
	if (locale === "hi") return hi_home_offerhover_agerating2(inputs)
	if (locale === "th") return th_home_offerhover_agerating2(inputs)
	if (locale === "ja") return ja_home_offerhover_agerating2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_offerhover_agerating2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_offerhover_agerating2(inputs)
	return ko_home_offerhover_agerating2(inputs)
});
export { home_offerhover_agerating2 as "home.offerHover.ageRating" }